import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const variantList = [
  'heading1',
  'heading2',
  'heading3',
  'heading4',
  'heading5',
  'heading6',
  'heading7',
  'heading8',
  'heading9',
  'heading10',
  'body',
  'body-small',
  'body-medium',
  'body-large',
  'body-xlarge',
  'body-xxlarge',
];
const colorList = [
  'black-bis',
  'grey',
  'grey-dark',
  'grey-darker',
  'grey-light',
  'grey-lighter',
  'white',
  'warning',
  'success',
  'success-dark',
  'danger',
  'color-inherit',
  'gold-dark'
];

const Typography = ({
  renderAs,
  className,
  children,
  variant,
  color,
  align,
  gutterBottom,
  noWrap,
  display,
  uppercase,
  capitalize,
  underline,
  strikeThrough,
  weight,
  loading,
  ...rest
}) => {
  const tagMapping = {
    heading1: 'h1',
    heading2: 'h2',
    heading3: 'h3',
    heading4: 'h4',
    heading5: 'h5',
    heading6: 'h6',
    heading7: 'h6',
    heading8: 'h6',
    heading9: 'h6',
    heading10: 'h6',
    body: 'p',
  };

  const ComponentTag = renderAs || tagMapping[variant] || 'span';

  const fontWeightStyles = {
    'has-text-weight-normal': weight === 400,
    'has-text-weight-medium': weight === 500,
    'has-text-weight-bold': weight === 700
  };

  return (
    <ComponentTag
      className={classnames(
        variant,
        color ? `has-text-${color}` : null,
        align ? `has-text-${align}` : null,
        gutterBottom ? `gutter-bottom-${gutterBottom}` : null,
        noWrap ? 'no-wrap' : null,
        display ? `is-${display}` : null,
        uppercase ? 'is-uppercase' : null,
        capitalize ? 'is-capitalized' : null,
        underline ? 'underline' : null,
        strikeThrough ? 'strike-through' : null,
        fontWeightStyles,
        loading ? 'loading' : null,
        className
      )}
      {...rest}
    >
      {children}
    </ComponentTag>
  );
};

Typography.propTypes = {
  renderAs: PropTypes.string,
  variant: PropTypes.oneOf(variantList),
  children: PropTypes.node,
  color: PropTypes.oneOf(colorList),
  align: PropTypes.string,
  gutterBottom: PropTypes.string,
  noWrap: PropTypes.bool,
  display: PropTypes.oneOf(['block', 'inline']),
  uppercase: PropTypes.bool,
  capitalize: PropTypes.bool,
  underline: PropTypes.bool,
  strikeThrough: PropTypes.bool,
  className: PropTypes.string,
  weight: PropTypes.oneOf([400, 500, 700]),
  loading: PropTypes.bool
};

Typography.defaultProps = {
  renderAs: null,
  variant: null,
  children: null,
  align: null,
  gutterBottom: null,
  color: null,
  noWrap: false,
  display: null,
  uppercase: false,
  capitalize: false,
  underline: false,
  strikeThrough: false,
  className: null,
  weight: null,
  loading: false
};
export { Typography };
